module.exports = "/_next/static/resources/photo-3-8a5dab2eb71d057c5ddf0214526fa50b.webp";